import { useEffect, useState } from "react";
import { File, Task, TaskResultType, TaskStatusEnum } from "multitool-sdk-core";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";

interface StatusProps {
  task?: Task;
}

const StatusAndResult: React.FC<StatusProps> = ({ task }) => {
  const [beforeImageURL, setBeforeImageURL] = useState<string>();
  const [resultImageURL, setResultImageURL] = useState<string>();

  useEffect(() => {
    if (task && task.result && task.resultType === TaskResultType.IMAGE) {
      Object.entries(task.args)
        .filter(([k]) => k.endsWith("Image"))
        .forEach(async ([, v]) => {
          const blob = await (v as File).readBinary();
          if (blob) {
            setBeforeImageURL(URL.createObjectURL(blob));
          }
        });
      task.result.read().then((blob: Blob) => {
        setResultImageURL(URL.createObjectURL(blob));
      });
    }
  }, [task]);

  return (
    <>
      {task && (
        <div>
          {task.status === TaskStatusEnum.running ? (
            "Calculating..."
          ) : task.status === TaskStatusEnum.success && task.result ? (
            task.resultType === TaskResultType.STRING ? (
              `Result: ${task.result}`
            ) : (
              <div style={{ maxWidth: "800px" }}>
                <a
                  download={`${task.result.name}.${task.result.extension}`}
                  href={resultImageURL}
                >
                  Download
                </a>
                <ReactCompareSlider
                  itemOne={
                    <ReactCompareSliderImage
                      src={beforeImageURL}
                      alt="Before"
                    />
                  }
                  itemTwo={
                    <ReactCompareSliderImage src={resultImageURL} alt="After" />
                  }
                />
              </div>
            )
          ) : task.status === TaskStatusEnum.failure ? (
            `Failed to calculate : ${task.error}`
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default StatusAndResult;
